import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ModalController } from "@ionic/angular/standalone";
import { IonHeader, IonToolbar, IonBackButton, IonTitle, IonContent } from "@ionic/angular/standalone";
import { DisplayService } from "@qid/core";
import { SexyModule } from '@qid/sexy';
import { AvatarRoundComponent } from '@qid/super';
import { Observable } from 'rxjs';
import { AccountAttributeType, ListAccountAttributeComponent, AccountAttributeViewComponent } from "../../../account-attribute";
import { AccountProfile } from "../../model/account-profile.model";
import { AccountProfileApi } from "../../services/account-profile.api";
import { AccountProfileFacade } from "../../state/account-profile.facade";
import { AccountProfileUtil } from "../../util/account-profile.util";

@Component({
  selector: 'oneqid-nx-edit-account-profile',
  templateUrl: './edit-account-profile.page.html',
  styleUrls: ['./edit-account-profile.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SexyModule,
    AvatarRoundComponent,
    AccountAttributeViewComponent,
    IonHeader,
    IonToolbar,
    IonBackButton,
    IonTitle,
    IonContent
  ],
})
export class EditAccountProfilePage implements OnInit {

  public profile$: Observable<AccountProfile> = this.accountProfileFacade.profile$

  constructor(private accountProfileApi: AccountProfileApi,
    private accountProfileFacade: AccountProfileFacade,
    private modalController: ModalController,
    private displayService: DisplayService
  ) {
  }

  ngOnInit() {
  }

  ionViewDidEnter() {

  }

  async readProfile() {
  }

  async createProfile() {
    const res = await this.accountProfileApi.create()
  }

  async onChangeAttributeClicked(attributeType: AccountAttributeType, label: string) {
    const modal = await this.modalController.create({
      component: ListAccountAttributeComponent,
      componentProps: {
        label: label,
        attributeTypeFilter: attributeType
      }
    })

    modal.present();
  }

  updateProfilePhoto = async (imageRes: any) => {
    try {
      await this.accountProfileFacade.updateDisplayPicture(imageRes.file)
    } catch (e) {
      this.displayService.toast({
        message: e,
        color: 'danger'
      })
    }

  }

  protected readonly AccountAttributeType = AccountAttributeType;
  protected readonly getAttributeByType = AccountProfileUtil.getAttributeByType;

  protected readonly AccountProfileUtil = AccountProfileUtil;
}
